export default __webpack_public_path__ + "static/media/Szpital1.75218552.png";